// src/components/admin/flows/canvas/ConnectionLine.js
import React from 'react';

const ConnectionLine = ({ start, end, isDark }) => {
    if (!start || !end) return null;

    const dy = Math.abs(end.y - start.y);
    const controlOffset = Math.max(50, dy * 0.4);

    const path = `M ${start.x} ${start.y} C ${start.x} ${start.y + controlOffset}, ${end.x} ${end.y - controlOffset}, ${end.x} ${end.y}`;

    return (
        <path
            d={path}
            fill="none"
            stroke={isDark ? '#60a5fa' : '#3b82f6'}
            strokeWidth={2}
            strokeDasharray="6 3"
            className="pointer-events-none"
            style={{ opacity: 0.7 }}
        />
    );
};

export default ConnectionLine;
